<header id="header" class="header">
    <nav class="navbar fixed-top navbar-expand-lg scrolling-navbar navbgColor">
        <img class="logo navbar-brand" href="" src="./assets/Images/Header/Accenture1.png">
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto no-margin">
                <li class="nav-item  waves-light headerDesc" mdbWavesEffect>
                    <span>
                        <a class="nav-linkCompany  text-uppercase text-white" href="#">
                            <strong>ASD</strong>
                            <span class="sr-only">(current)</span></a>
                    </span>

                </li>
            </ul>

        </div>
    </nav>
</header>
<div class="bgImage">
<section class=" d-flex align-items-center offering z-depth-5 section notFound  ">
    <div class="container " data-aos="fade-up">
        <div class="section-title">
           
            <h4></h4>
            <h1 class="ml-5  mt-5 iconColor">Application is down for Maintainance.
            </h1>

           
        </div>

    </div>
    <section>
    <div>